import { fetchDataPost } from "../../controler/comunicacao";
import { useState, useEffect, useMemo, useCallback } from "react";
import ChartBar from "../../components/Charts/ChartBar.jsx";
import ChartBarStacked from "../../components/Charts/ChartBarStacked.jsx";
import ChartBarStackedSubCategories from "../../components/Charts/ChartBarStackedSubCategories.jsx";
import CardChart from "../../components/Card/Card.jsx";
// import TableEstados from "../../components/TableEstados/TableEstados.jsx";
import ChartDonut from "../../components/Charts/ChartDonut.jsx";
import ChartBar2 from "../../components/Charts/ChartBar2.jsx";
import ChartLine from "../../components/Charts/ChartLine.jsx";
import ChartLine2 from "../../components/Charts/ChartLine2.jsx";
import ChartBarIncidence from "../../components/Charts/ChartBarIncidence.jsx";
import Pyramid from "../../components/Charts/Pyramid.jsx"
import Filter from "../../components/Filter/Filter.jsx";
import LoadingModal from '../../components/LoadingModal/LoadingModal.jsx';

import "../Dashboard.css";

import { useQuery } from "@tanstack/react-query";

const endpointsGraphs = [
  { key: "incidencia", url: "/api/grafico1" },
  { key: "sexo", url: "/api/grafico2" },
  { key: "faixaEtaria", url: "/api/grafico3" },
  { key: "raca", url: "/api/grafico4" },
  { key: "racaAno", url: "/api/grafico5" },
  { key: "sitVunAno", url: "/api/grafico6" },
  // { key: "incEstados", url: "/api/grafico7" },
  { key: "formaClinica", url: "/api/grafico8" },
  { key: "pulmConf", url: "/api/grafico9" },
  { key: "pulmTestRapAno", url: "/api/grafico10" },
  { key: "pulmTestRapEstados", url: "/api/grafico11" },
  { key: "reaCulNovERetAno", url: "/api/grafico12" },
  { key: "contatosExaminados", url: "/api/grafico13" },
  { key: "casosSolReaTestHIV", url: "/api/grafico14" },
  { key: "realTestHIVNovos", url: "/api/grafico15" },
  { key: "usoTarvTbHivAno", url: "/api/grafico16" },
  { key: "casosCoinTBHIV", url: "/api/grafico17" },
  { key: "usoTarvTbHiv", url: "/api/grafico18" },
  { key: "retratamento", url: "/api/grafico19" },
  { key: "retratamentoObservado", url: "/api/grafico20" },
  { key: "desfechosTratamentosHiv", url: "/api/grafico21" },
  { key: "desfechosTratamentos", url: "/api/grafico22" },
  { key: "desfechosTratamentosPopulacaoVulneravel", url: "/api/grafico23" },
];

const SECONDS = 1000;
const MINUTES = 60;
const HOURS = 60;
const DAYS = 24;

const useData = (SITUACAO, ANO_DIAG, CAPITAL, CS_RACA, CS_SEXO, FAIXA_ET, NOME_MUNIC, REGIAO, SIGLA_UF) => {

  const hash = `${SITUACAO.map(x => x.value).join(',')}-${ANO_DIAG.map(x => x.value).join(',')}-${CAPITAL.map(x => x.value).join(',')}-${CS_RACA.map(x => x.value).join(',')}-${CS_SEXO.map(x => x.value).join(',')}-${FAIXA_ET.map(x => x.value).join(',')}-${NOME_MUNIC.map(x => x.value).join(',')}-${REGIAO.map(x => x.value).join(',')}-${SIGLA_UF.map(x => x.value).join(',')}-version-001`;
  return useQuery({
    queryKey: [hash],
    queryFn: async () => {
      const results = await Promise.all(
        endpointsGraphs.map(({ url }) => fetchDataPost(url,
          { "SITUACAO": SITUACAO.map(x => x.value), "ANO_DIAG": ANO_DIAG.map(x => x.value), "CAPITAL": CAPITAL.map(x => x.value), "CS_RACA": CS_RACA.map(x => x.value), "CS_SEXO": CS_SEXO.map(x => x.value), "FAIXA_ET": FAIXA_ET.map(x => x.value), "NOME_MUNIC": NOME_MUNIC.map(x => x.value), "REGIAO": REGIAO.map(x => x.value), "SIGLA_UF": SIGLA_UF.map(x => x.value) }
        ))
      );
      const dataObj = {};
      for (let i = 0; i < results.length; i++) {
        dataObj[endpointsGraphs[i].key] = results[i];
      }
      console.log("RESULTS:", results);
      return dataObj;
    },
    staleTime: SECONDS * MINUTES * HOURS * DAYS * 15, // cache por 15 dias
    cacheTime: SECONDS * MINUTES * HOURS * DAYS * 15, // cache por 15 dias
    refetchOnWindowFocus: false,
  });
};

function checkYearOrMonth(dataYearMonth, key) {
  try {
    if (dataYearMonth[key][0].hasOwnProperty("MES_DIAG")) return "MES_DIAG";
    return "ANO_DIAG";
  } catch (e) {
    return null;
  }
}

function checkYearOrMonthString(dataYearMonth, key) {
  if (!dataYearMonth) return null;
  try {
    const firstKey = Object.keys(dataYearMonth)[0];
    if (dataYearMonth[firstKey].substring(3, 4) === "M") return "MES_DIAG";
    if (dataYearMonth[key].substring(3, 4) === "A") return "ANO_DIAG";
    return null;
  } catch (e) {
    return null;
  }
}

function checkUFOrMunicipio(dataUfMunicipio) {
  try {
    if (dataUfMunicipio.dados === undefined) return null;
    if (dataUfMunicipio.dados[3] === "S") return "SIGLA_UF";
    return "NOME_MUNIC";
  } catch (e) {
    return null;
  }
}

function DashBoard() {
  const [ANO_DIAG, setANO_DIAG] = useState([{ value: "TODOS", label: "TODOS" }]);
  const [CAPITAL] = useState([{ value: "TODOS", label: "TODOS" }]);
  const [CS_RACA, setCS_RACA] = useState([{ value: "TODOS", label: "TODOS" }]);
  const [CS_SEXO, setCS_SEXO] = useState([{ value: "TODOS", label: "TODOS" }]);
  const [FAIXA_ET, setFAIXA_ET] = useState([{ value: "TODOS", label: "TODOS" }]);
  const [REGIAO, setREGIAO] = useState([{ value: "TODOS", label: "TODOS" }]);
  const [SIGLA_UF, setSIGLA_UF] = useState([{ value: "TODOS", label: "TODOS" }]);
  const [NOME_MUNIC, setNOME_MUNIC] = useState([{ value: "TODOS", label: "TODOS" }]);
  const [SITUACAO, setSITUACAO] = useState([{ value: "TODOS", label: "TODOS" }]);

  const [areFiltersOpen, setAreFiltersOpen] = useState(false);
  const [userDismissedLoading, setUserDismissedLoading] = useState(false);

  let { data, isLoading } = useData(SITUACAO, ANO_DIAG, CAPITAL, CS_RACA, CS_SEXO, FAIXA_ET, NOME_MUNIC, REGIAO, SIGLA_UF);

  useEffect(() => {
    if (isLoading) {
      setUserDismissedLoading(false);
    }
  }, [isLoading, SITUACAO, ANO_DIAG, CAPITAL, CS_RACA, CS_SEXO, FAIXA_ET, NOME_MUNIC, REGIAO, SIGLA_UF]);


  const parsedData = useMemo(() => {
    if (!data) return {};
    return {
      pulmConf: data.pulmConf?.dados ? JSON.parse(data.pulmConf.dados) : [],
      pulmTestRapEstados: data.pulmTestRapEstados?.dados ? JSON.parse(data.pulmTestRapEstados.dados) : [],
      contatosExaminados: data.contatosExaminados?.dados ? JSON.parse(data.contatosExaminados.dados) : [],
      realTestHIVNovos: data.realTestHIVNovos?.dados ? JSON.parse(data.realTestHIVNovos.dados) : [],
      casosCoinTBHIV: data.casosCoinTBHIV?.dados ? JSON.parse(data.casosCoinTBHIV.dados) : [],
      usoTarvTbHiv: data.usoTarvTbHiv?.dados ? JSON.parse(data.usoTarvTbHiv.dados) : [],
      retratamentoObservado: data.retratamentoObservado?.dados ? JSON.parse(data.retratamentoObservado.dados) : [],
    };
  }, [data]);

  const handleFilterUpdate = useCallback((
    SITUACAO,
    ANO_DIAG,
    CS_RACA,
    CS_SEXO,
    FAIXA_ET,
    SIGLA_UF,
    REGIAO,
    NOME_MUNIC
  ) => {
    setSITUACAO(SITUACAO)
    setANO_DIAG(ANO_DIAG);
    setCS_RACA(CS_RACA);
    setCS_SEXO(CS_SEXO);
    setFAIXA_ET(FAIXA_ET);
    setSIGLA_UF(SIGLA_UF);
    setREGIAO(REGIAO);
    setNOME_MUNIC(NOME_MUNIC);
  }, []);

  return (
    <section className="container-fluid dashboard px-0">

      {/* Filters */}
      <div className="titulo p-3 d-flex justify-content-between align-items-center">
        <div className="titulo-nome"> {SITUACAO[0].value === "OBITO"
          ? "Óbitos por tuberculose"
          : SITUACAO[0].value === "ABANDONO"
            ? "Interrupções de tratamento"
            : "Notificações de tuberculose"}</div>
        <button className="filter-button" onClick={() => areFiltersOpen ? setAreFiltersOpen(false) : setAreFiltersOpen(true)}>Filtros</button>
      </div>
      <Filter open={areFiltersOpen} useData={handleFilterUpdate} />

      <LoadingModal show={isLoading && !userDismissedLoading} onHide={() => setUserDismissedLoading(true)} />
      {/* CARDS */}
      <div className="row gx-3 gy-3 mb-3">
        {/* CARD INCIDENCIA 1*/}
        <CardChart
          title={SITUACAO[0].value === "ABANDONO" ? "Taxa de interrupção de tratamento por ano de diagnóstico" : "Coeficiente de incidência e número de casos por ano de diagnóstico"}
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal1"
          loading={isLoading}
          cols="col-12"
          chartData={data?.incidencia ?? null}
        >
          {((!data) ?
            null
            : < ChartBarIncidence data={data.incidencia} categoryKey={checkYearOrMonth(data, "incidencia")} seriesNameLine={SITUACAO[0].value === "ABANDONO" ? "Taxa" : "Incidência"} titleY2={SITUACAO[0].value === "ABANDONO" ? "Taxa" : "Incidência"} />)}
        </CardChart>

        {/* CARD SEXO 2*/}
        <CardChart
          title="Por sexo (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal2"
          loading={isLoading}
          cols="col-sm-12 col-md-12 col-lg-6"
          chartData={data?.sexo ?? null}
        >
          {((!data) ?
            null :
            <ChartBar
              data={data.sexo}
              categoryKey="CS_SEXO"
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Sexo"
              titleY="Porcentagem"
              seriesName="Distribuição de Casos"
              isHorizontal={false}
              colorMap={{ Masculino: "#4296bd", Feminino: "#41be86" }}
            />)}
        </CardChart>

        {/* CARD SEXO 3*/}
        <CardChart
          title="Por faixa etaria"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal3"
          loading={isLoading}
          cols="col-sm-12 col-md-12 col-lg-6"
          chartData={data?.faixaEtaria ?? null}
        >
          {((!data) ?
            null :
            <Pyramid
              data={data.faixaEtaria}
              categoryKey="CS_SEXO"
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Sexo"
              titleY="Porcentagem"
              seriesName="Distribuição de Casos"
              isHorizontal={false}
            />)}
        </CardChart>

        {/* CARD RAÇA 4*/}
        <CardChart
          title="Por Raça/cor (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal4"
          loading={isLoading}
          cols="col-sm-12 col-md-12 col-lg-6"
          chartData={data?.raca ?? null}
        >
          {((!data) ?
            null :
            <ChartBar
              data={data.raca}
              categoryKey="CS_RACA"
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Raça/Cor"
              titleY="Porcentagem"
              seriesName="Distribuição de Casos"
              isHorizontal={false}
              colorMap={{
                "Branca":                    "#A0C4FF",
                "Preta":                     "#4A4A4A",
                "Amarela":                   "#FFD166",
                "Parda":                     "#C8956C",
                "Indigena":                  "#6B8F4E",
                "Ignorado/sem informacao":   "#B0B0B0",
              }}
            />)}
        </CardChart>

        {/* CARD RAÇA POR ANO 5*/}
        <CardChart
          title="Casos por Raça/cor e Ano diagnóstico (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal5"
          loading={isLoading}
          cols="col-12"
          chartData={data?.racaAno ?? null}
        >
          {((!data) ?
            null :

            <ChartBarStacked
              data={data.racaAno}
              categoryKey={checkYearOrMonth(data, "racaAno")} // Chave para o eixo X
              categorie="CS_RACA" // Chave para as categorias
              valueKey="NumeroCasos" // Chave para valores numéricos
              percentageKey="Porcentagem" // Chave para porcentagem
              chartType="bar" // Tipo de gráfico
              titleX="Ano/Mês de Diagnóstico" // Título do eixo X
              titleY="Porcentagem (%)" // Título do eixo Y
              seriesName="Casos por Raça" // Nome genérico da série
              isHorizontal={false} // Gráfico vertical
              showPercentage={true} // Exibir valores como porcentagem
              max={100}
            />)}
        </CardChart>

        {/* CARD SITUAÇÃO VULNERABILIDADE POR ANO 6 */}
        <CardChart
          title="Porcentagem por Situação de Vulnerabilidade e Ano diagnóstico"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal6"
          loading={isLoading}
          cols="col-12"
          chartData={data?.sitVunAno ?? null}
        >
          {((!data) ?
            null :
            <ChartBarStacked
              data={data.sitVunAno}
              categoryKey={checkYearOrMonth(data, "sitVunAno")} // Chave para o eixo X
              categorie="POP_TIPO" // Chave para as categorias
              valueKey="NumeroCasos" // Chave para valores numéricos
              percentageKey="Porcentagem" // Chave para porcentagem
              chartType="bar" // Tipo de gráfico
              titleX="Ano/Mês de Diagnóstico" // Título do eixo X
              titleY="Porcentagem (%)" // Título do eixo Y
              seriesName="Casos por Situação de Vulnerabilidade" // Nome genérico da série
            />)}
        </CardChart>

        {/* CARD FORMA CLINICA 8 */}
        <CardChart
          title="Por Forma Clínica (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal8"
          loading={isLoading}
          cols="col-sm-12 col-md-12 col-lg-6"
          chartData={data?.formaClinica ?? null}
        >
          {((!data) ?
            null :
            <ChartDonut
              data={data.formaClinica}
              categoryKey="FORMA"
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              seriesName="Distribuição de Casos"
            />)}
        </CardChart>

        {/* CARD SITUAÇÃO VULNERABILIDADE POR ANO 9 */}
        <CardChart
          title="Casos novos de tuberculose pulmonar com confirmacao laboratorial %"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal9"
          loading={isLoading}
          cols="col-12"
          chartData={parsedData.pulmConf?.length ? parsedData.pulmConf : null}
        >
          {((!data) ?
            null :
            <ChartBar2
              data={parsedData.pulmConf}
              geralValue={data.pulmConf.geral}
              categoryKey={checkUFOrMunicipio(data.pulmConf)}
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Região"
              titleY="Porcentagem (%)"
              seriesName="Distribuição de Casos"
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD PULMONAR TESTE RÁPIDO 10 */}
        <CardChart
          title="Casos novos de Tuberculose Pulmonar com teste rápido (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal10"
          loading={isLoading}
          cols="col-12"
          chartData={data?.pulmTestRapAno ?? null}
        >
          {((!data) ?
            null :
            <ChartLine
              data={data.pulmTestRapAno}
              categoryKey={checkYearOrMonth(data, "pulmTestRapAno")}
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Ano/Mês de Diagnóstico"
              titleY="Porcentagem (%)"
              seriesName="Distribuição de Casos"
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD PULMONAR TESTE RÁPIDO POR ESTADOS 11 */}
        <CardChart
          title="Casos novos de Tuberculose Pulmonar com teste rápido por Estados (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal11"
          loading={isLoading}
          cols="col-12"
          chartData={parsedData.pulmTestRapEstados?.length ? parsedData.pulmTestRapEstados : null}
        >
          {((!data) ?
            null :
            <ChartBar2
              data={parsedData.pulmTestRapEstados}
              geralValue={data.pulmTestRapEstados.geral}
              categoryKey={checkUFOrMunicipio(data.pulmTestRapEstados)}
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Região"
              titleY="Porcentagem (%)"
              seriesName="Distribuição de Casos"
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD REALIZAÇÃO DE CULTURA ENTRE OS NOVOS CASOS E RETRATAMENTO POR ANO DE DIAGNOSTICO 12 */}
        <CardChart
          title="Realização de Cultura entre os novos casos e retratamento por ano de diagnóstico (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal12"
          loading={isLoading}
          cols="col-12"
          chartData={null}
        >
          {((!data) ?
            null :
            <ChartLine2
              data={data.reaCulNovERetAno}
              categoryKey={checkYearOrMonthString(data.reaCulNovERetAno, "casos_novos")}
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Ano/Mês de Diagnóstico"
              titleY="Porcentagem (%)"
              seriesNames={["Casos Novos", "Retratamentos"]}
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD CONTATOS EXAMINADOS ENTRE OS CONTATOS IDENTIFICADOS DOS CASOS NOVOS DE TUBERCULOSE PULMONAR 13 */}
        <CardChart
          title="Contatos examinados entre os contatos identificados dos casos novos de tuberculose pulmonar com confirmacao laboratorial (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal13"
          loading={isLoading}
          cols="col-12"
          chartData={parsedData.contatosExaminados?.length ? parsedData.contatosExaminados : null}
        >
          {((!data) ?
            null :
            <ChartBar2
              data={parsedData.contatosExaminados}
              geralValue={data.contatosExaminados.geral}
              categoryKey={checkUFOrMunicipio(data.contatosExaminados)}
              valueKey="NU_COMU_EX"
              percentageKey="porcentagem"
              titleX="Região"
              titleY="Porcentagem (%)"
              seriesName="Distribuição de Casos"
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD CASOS SOLICITARAM REALIZAÇÃO DE TESTE RÁPIDO PARA HIV 14*/}
        <CardChart
          title="Casos novos de Tuberculose Pulmonar que solicitaram realização de teste para HIV e coinfecção TB/HIV por ano diagnóstico (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal14"
          loading={isLoading}
          cols="col-12"
          chartData={null}
        >
          {((!data) ?
            null :
            <ChartLine2
              data={data.casosSolReaTestHIV}
              categoryKey={checkYearOrMonthString(data.casosSolReaTestHIV, "Coinfecção TB-HIV")}
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Ano/Mês de Diagnóstico"
              titleY="Porcentagem (%)"
              seriesNames={[
                "Coinfecção TB-HIV",
                "Teste realizado",
                "Teste solicitado",
              ]}
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD REALIZAÇÃO DE TESTE PARA HIV ENTRE OS CASOS NOVOS 15*/}
        <CardChart
          title="Realização de teste para HIV entre os casos novos de Tuberculose Pulmonar (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal15"
          loading={isLoading}
          cols="col-12"
          chartData={parsedData.realTestHIVNovos?.length ? parsedData.realTestHIVNovos : null}
        >
          {((!data) ?
            null :
            <ChartBar2
              data={parsedData.realTestHIVNovos}
              geralValue={data.realTestHIVNovos.geral}
              categoryKey={checkUFOrMunicipio(data.realTestHIVNovos)}
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Região"
              titleY="Porcentagem (%)"
              seriesName="Distribuição de Casos"
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD USO DE TARV NOS CASOS NOVOS DE TB-HIV POR ANO DIAGNOSTICO 16 */}
        <CardChart
          title="Uso de TARV nos casos novos de TB-HIV por ano diagnóstico (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal16"
          loading={isLoading}
          cols="col-12"
          chartData={data?.usoTarvTbHivAno ?? null}
        >
          {((!data) ?
            null :
            <ChartBarStacked
              data={data.usoTarvTbHivAno}
              categoryKey={checkYearOrMonth(data, "usoTarvTbHivAno")} // Chave para o eixo X
              categorie="ANT_RETRO" // Chave para as categorias
              valueKey="NumeroCasos" // Chave para valores numéricos
              percentageKey="Porcentagem" // Chave para porcentagem
              chartType="bar" // Tipo de gráfico
              titleX="Ano/Mês de Diagnóstico" // Título do eixo X
              titleY="Porcentagem (%)" // Título do eixo Y
              seriesName="Casos por Raça" // Nome genérico da série
              isHorizontal={false} // Gráfico vertical
              showPercentage={true} // Exibir valores como porcentagem
              max={100}
            />)}
        </CardChart>

        {/* CARD CASOS COINFECÇÃO TB/HIV 17 */}
        <CardChart
          title="Casos de coinfecção TB/HIV por ano diagnóstico (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal17"
          loading={isLoading}
          cols="col-12"
          chartData={parsedData.casosCoinTBHIV?.length ? parsedData.casosCoinTBHIV : null}
        >
          {((!data) ?
            null :
            <ChartBar2
              data={parsedData.casosCoinTBHIV}
              geralValue={data.casosCoinTBHIV.geral}
              categoryKey={checkUFOrMunicipio(data.casosCoinTBHIV)}
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Região"
              titleY="Porcentagem (%)"
              seriesName="Distribuição de Casos"
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD USO TARV TB/HIV POR ESTADO 18 */}
        <CardChart
          title="Uso TARV entre os casos de coinfecção TB/HIV por ano diagnóstico (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal18"
          loading={isLoading}
          cols="col-12"
          chartData={parsedData.usoTarvTbHiv?.length ? parsedData.usoTarvTbHiv : null}
        >
          {((!data) ?
            null :
            <ChartBar2
              data={parsedData.usoTarvTbHiv}
              geralValue={data.usoTarvTbHiv.geral}
              categoryKey={checkUFOrMunicipio(data.usoTarvTbHiv)}
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Região"
              titleY="Porcentagem (%)"
              seriesName="Distribuição de Casos"
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD CASOS DE RETRATAMENTO DE TUBERCULOSE POR ANO 19 */}
        <CardChart
          title="Casos de retratamento de Tuberculose por ano de diagnóstico (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal19"
          loading={isLoading}
          cols="col-12"
          chartData={data?.retratamento ?? null}
        >
          {((!data) ?
            null :
            <ChartLine
              data={data.retratamento}
              categoryKey={checkYearOrMonth(data, "retratamento")}
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Ano/Mês de Diagnóstico"
              titleY="Porcentagem (%)"
              seriesName="Distribuição de Casos"
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD CASOS DE RETRATAMENTO DIRETAMENTE OBSERVADO DE TUBERCULOSE POR ESTADO 20 */}
        <CardChart
          title="Casos de retratamento diretamente observado de Tuberculose por Estado (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal20"
          loading={isLoading}
          cols="col-12"
          chartData={parsedData.retratamentoObservado?.length ? parsedData.retratamentoObservado : null}
        >
          {((!data) ?
            null :
            <ChartBar2
              data={parsedData.retratamentoObservado}
              geralValue={data.retratamentoObservado.geral}
              categoryKey={checkUFOrMunicipio(data.retratamentoObservado)}
              valueKey="NumeroCasos"
              percentageKey="Porcentagem"
              titleX="Estados"
              titleY="Porcentagem (%)"
              seriesName="Distribuição de Casos"
              showPercentage={true}
            />)}
        </CardChart>

        {/* CARD DESFECHOS DE TRATAMENTO DOS CASOS NOVOS  DE COINFECCAO TB-HIV SEGUNDO USO DE TARV 21 */}
        <CardChart
          title="Desfechos de tratamento dos casos novos de coinfecção TB-HIV segundo uso de TARV (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal21"
          loading={isLoading}
          cols="col-12"
          chartData={data?.desfechosTratamentosHiv ?? null}
        >
          {((!data) ?
            null :
            <ChartBarStacked
              data={data.desfechosTratamentosHiv}
              categoryKey="ANT_RETRO" // Chave para o eixo X
              categorie="SITUA_ENCE" // Chave para as categorias
              valueKey="Porcentagem" // Chave para valores numéricos
              percentageKey="Porcentagem" // Chave para porcentagem
              chartType="bar" // Tipo de gráfico
              titleX="Encerramento" // Título do eixo X
              titleY="Porcentagem (%)" // Título do eixo Y
              seriesName="Casos por Situação de Vulnerabilidade" // Nome genérico da série
              max={100}
            />)}
        </CardChart>

        {/* 22 */}
        <CardChart
          title="Desfechos de tratamento dos casos novos de tuberculose pulmonar com confirmação laboratorial por ano de diagnóstico (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal22"
          loading={isLoading}
          cols="col-12"
          chartData={data?.desfechosTratamentos ?? null}
        >
          {((!data) ?
            null :
            <ChartBarStacked
              data={data.desfechosTratamentos}
              categoryKey={checkYearOrMonth(data, "desfechosTratamentos")} // Chave para o eixo X
              categorie="SITUA_ENCE" // Chave para as categorias
              valueKey="Porcentagem" // Chave para valores numéricos
              percentageKey="Porcentagem" // Chave para porcentagem
              chartType="bar" // Tipo de gráfico
              titleX="Ano/Mês de Diagnóstico" // Título do eixo X
              titleY="Porcentagem (%)" // Título do eixo Y
              seriesName="Casos por Situação de Vulnerabilidade" // Nome genérico da série
              max={100}
            />)}
        </CardChart>

        {/* 23 */}
        <CardChart
          title="Desfechos de tratamento entre os casos novos de tuberculose diagnosticados em populações vulneráveis por ano de diagnóstico (%)"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal23"
          loading={isLoading}
          cols="col-12"
          chartData={data?.desfechosTratamentosPopulacaoVulneravel ?? null}
        >
          {((!data) ?
            null :
            <ChartBarStackedSubCategories
              data={data.desfechosTratamentosPopulacaoVulneravel}
              categoryKey={checkYearOrMonth(data, "desfechosTratamentosPopulacaoVulneravel")} // Chave para o eixo X
              categorie="SITUA_ENCE" // Chave para as categorias
              valueKey="Percentual" // Chave para valores numéricos
              percentageKey="Percentual" // Chave para porcentagem
              chartType="bar" // Tipo de gráfico
              titleX="Ano de Diagnóstico" // Título do eixo X
              titleY="Porcentagem (%)" // Título do eixo Y
              seriesName="Casos por Situação de Vulnerabilidade" // Nome genérico da série
              max={100}
            />)}
        </CardChart>
      </div>
    </section >
  );
}

export default DashBoard;
